import type {SVGProps} from 'react';

export const ArrowRightIcon = (props: SVGProps<SVGSVGElement>) => {
    return (
        <svg
            {...props}
            viewBox='0 0 24 24'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path d='M4 11.0001V13.0001H16L10.5 18.5001L11.92 19.9201L19.84 12.0001L11.92 4.08008L10.5 5.50008L16 11.0001H4Z' />
        </svg>
    );
};
